/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Класс-одиночка для динамической загрузки и инициализации Yandex Maps API (window.ymaps).
 */
export class YandexMap {
  private static instance: YandexMap
  private static loadPromise: Promise<typeof window.ymaps> | null = null

  /**
   * Приватный конструктор для реализации паттерна Singleton.
   * Используйте YandexMap.init() для получения экземпляра.
   * @private
   */
  private constructor() {}

  /**
   * Загружает скрипт Yandex Maps API, если он ещё не был загружен.
   * @private
   * @return {Promise<any>} Промис с объектом window.ymaps.
   */
  private static async loadMap(): Promise<typeof window.ymaps> {
    if (YandexMap.loadPromise) {
      return YandexMap.loadPromise
    }

    if (typeof window.ymaps !== 'undefined') {
      return Promise.resolve(window.ymaps)
    }

    YandexMap.loadPromise = new Promise<typeof window.ymaps>(
      (resolve, reject) => {
        const script = document.createElement('script')
        script.src =
          'https://api-maps.yandex.ru/2.1/?apikey=f1166b66-16ac-417c-b38f-d3a84ef5c59e&lang=ru_RU'

        script.onload = async () => {
          if (typeof window.ymaps !== 'undefined') {
            resolve(window.ymaps)
          } else {
            reject(new Error('window.ymaps object not found after script load'))
          }
        }

        script.onerror = () =>
          reject(new Error('Failed to load Yandex Maps script'))
        document.head.appendChild(script)
      }
    )

    return YandexMap.loadPromise
  }

  /**
   * Инициализирует и возвращает единственный экземпляр YandexMap.
   * @return {Promise<YandexMap>} Промис с экземпляром YandexMap.
   */
  public static async init(): Promise<YandexMap> {
    if (!YandexMap.instance) {
      YandexMap.instance = new YandexMap()
      await YandexMap.loadMap()
    }

    return YandexMap.instance
  }

  /**
   * Возвращает объект API Yandex Maps (window.ymaps) после загрузки.
   * @return {Promise<any>} Промис с объектом window.ymaps.
   */
  public static async getAPI(): Promise<any> {
    const api = await YandexMap.loadMap()
    return api
  }
}
